import React from "react";
import { cn } from "@/lib/utils";
interface TypingIndicatorProps {
  className?: string;
}

export const TypingIndicator: React.FC<TypingIndicatorProps> = ({ className }) => {
  const dots = [0, 150, 300];

  return (
    <div className={cn("flex items-center gap-2", className)} data-testid="typing-indicator">
      <div className="animate-pulse flex gap-1">
        {dots.map((delay) => (
          <div
            key={delay}
            className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"
            style={{ animationDelay: `${delay}ms` }}
          />
        ))}
      </div>
    </div>
  );
};
